import Cookies from 'js-cookie'

const TokenKey = 'User-Token'
const PhoneKey = 'User-Phone'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function getClickId() {
  return Cookies.get('click_id')
}

export function setClickId(id) {
  return Cookies.set('click_id', id)
}

export function getUtmSource() {
  return Cookies.get('utm_source')
}

export function setUtmSource(utm) {
  return Cookies.set('utm_source', utm)
}

export function getAffSid() {
  return Cookies.get('aff_sid')
}

export function setAffSid(data) {
  return Cookies.set('aff_sid', data)
}

export function getUtmMedium() {
  return Cookies.get('utm_medium')
}

export function setUtmMedium(utm) {
  return Cookies.set('utm_medium', utm)
}

export function getVer() {
  return Cookies.get('version')
}

export function setVer(v) {
  return Cookies.set('version', v)
}

export function getRefer() {
  return Cookies.get('refer')
}

export function setRefer(refer) {
  return Cookies.set('refer', refer)
}

export function setPhone(phone) {
  return Cookies.set(PhoneKey, phone)
}

export function getPhone() {
  return Cookies.get(PhoneKey)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setMoney(phone) {
    return Cookies.set('money', phone)
}
  
export function getMoney() {
    return Cookies.get('money')
}

export function setPartner(phone) {
    return Cookies.set('partner', phone)
}
  
export function getPartner() {
    return Cookies.get('partner')
}

export function setLogo(phone) {
    return Cookies.set('logo', phone)
}
  
export function getLogo() {
    return Cookies.get('logo')
}

export function setTimeCountDown(phone) {
    return Cookies.set('timeCountDown', phone)
}
  
export function getTimeCountDown() {
    return Cookies.get('timeCountDown')
}

export function setTimeCountDownPartner(phone) {
  return Cookies.set('timeCountDownPartner', phone)
}

export function getTimeCountDownPartner() {
  return Cookies.get('timeCountDownPartner')
}